import React from 'react'

import ProfileWorkingInformation from '@/pages/Users/ProfileWorkingInformation'
import ProfileDemosIndex from '@/pages/Users/ProfileDemosIndex'
import ProfileTags from '@/pages/Users/ProfileTags'
import ProfileEducationIndex from '@/pages/Users/ProfileEducationIndex'

// My work tab: what you charge, what you want, what you've made, how search
// finds you. Demos first because that is what producers actually open.
const ProfileWork = () => (
  <div className='space-y-10'>
    <ProfileDemosIndex />
    <ProfileWorkingInformation />
    <ProfileTags />
    <ProfileEducationIndex />
  </div>
)

export default ProfileWork
